export default {
    // 中
    zhCN: {
        fill_in_at_least_one_query_condition: '至少填写一个查询条件',
        query_time: '查询时间',
        full_query: '全量查询',
        organization_code: '组织CODE',
        organization_name: '组织名称',
        country: '国家',
        number_of_cases: '案例总数',
        number_of_case_responses: '24小时案件答复数量',
        response_rate: '24小时答复比率',
    },
    // 英
    enUS: {
        fill_in_at_least_one_query_condition: 'Fill in at least one query condition',
        query_time: 'Query time',
        full_query: 'Full query',
        organization_code: 'Organization code',
        organization_name: 'Organization name',
        country: 'Country',
        number_of_cases: 'Number of cases',
        number_of_case_responses: 'Number of 24-hour case responses',
        response_rate: '24-hour response rate',
    },
    // 德
    deDE: {
        fill_in_at_least_one_query_condition: 'Füllen Sie mindestens eine Abfragebedingung aus',
        query_time: 'Abfragezeit',
        full_query: 'Vollständige Abfrage',
        organization_code: 'Organisationscode',
        organization_name: 'Organisationsname',
        country: 'Land',
        number_of_cases: 'Gesamtzahl der Fälle',
        number_of_case_responses: 'Anzahl der 24-Stunden-Fallantworten',
        response_rate: 'Reaktionsrate rund um die Uhr',
    },
    // 法
    frFR: {
        fill_in_at_least_one_query_condition: 'Remplissez au moins une condition de demande',
        query_time: 'Temps de requête',
        full_query: 'Requête complète',
        organization_code: 'Code organisation',
        organization_name: 'Nom organisation',
        country: 'Pays',
        number_of_cases: 'Nombre de cas',
        number_of_case_responses: 'Nombre de réponses de cas en 24 heures',
        response_rate: 'Taux de réponse 24 heures',
    },
    // 意大利
    itIT: {
        fill_in_at_least_one_query_condition: 'Compilare almeno una condizione di query',
        query_time: 'Tempo di Query',
        full_query: 'Query Completa',
        organization_code: 'Codice Organizzazione',
        organization_name: 'Nome Organizzazione',
        country: 'Paese',
        number_of_cases: 'Numero totale di casi',
        number_of_case_responses: 'Numero di risposte al caso per 24 ore',
        response_rate: 'Tasso di risposta 24 ore',
    },
    // 荷兰
    nlNL: {
        fill_in_at_least_one_query_condition: 'Vul ten minste één query voorwaarde in',
        query_time: 'Query time',
        full_query: 'Volledige query',
        organization_code: 'Organisatie code',
        organization_name: 'Organisatie naam',
        country: 'Land',
        number_of_cases: 'Totaal aantal gevallen',
        number_of_case_responses: 'Aantal 24-uurs antwoorden op gevallen',
        response_rate: '24-uursresponspercentage',
    },
    // 越南
    viVN: {
        fill_in_at_least_one_query_condition: 'Ít nhất điền một điều kiện tìm kiếm',
        query_time: 'Thời gian truy vấn',
        full_query: 'Tra cứu toàn bộ',
        organization_code: 'Mã tổ chức',
        organization_name: 'Tên tổ chức',
        country: 'Quốc gia',
        number_of_cases: 'Số lượng trường hợp',
        number_of_case_responses: 'Số lượng câu trả lời trong 24 giờ',
        response_rate: 'Tỷ lệ trả lời 24 giờ',
    },
    // 西班牙
    esES: {
        fill_in_at_least_one_query_condition: 'Al menos complete un criterio de búsqueda',
        query_time: 'Consulta de tiempo',
        full_query: 'Consulta completa',
        organization_code: 'Código de la organización',
        organization_name: 'Nombre de la organización',
        country: 'País',
        number_of_cases: 'Número total de casos',
        number_of_case_responses: 'Número de respuestas a casos en 24 horas',
        response_rate: 'Tasa de respuesta de 24 horas',
    },
    // 葡萄牙
    ptBR: {
        fill_in_at_least_one_query_condition: 'Preencha pelo menos uma condição de consulta',
        query_time: 'Tempo de consulta',
        full_query: 'Consulta completa',
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        country: 'País',
        number_of_cases: 'Número total de casos',
        number_of_case_responses: 'Número de respostas aos casos de 24 horas',
        response_rate: 'Taxa de resposta 24 horas',
    },
    // 波兰
    plPL: {
        fill_in_at_least_one_query_condition: 'Wypełnij co najmniej jeden warunek zapytania',
        query_time: 'Data zapytania',
        full_query: 'Pełne zapytanie',
        organization_code: 'Kod organizacji',
        organization_name: 'Nazwa organizacji',
        country: 'Kraj',
        number_of_cases: 'Łączna liczba spraw',
        number_of_case_responses: 'Liczba 24-godzinnych odpowiedzi na sprawy',
        response_rate: 'Wskaźnik reakcji całodobowej',
    },
    // 土耳其
    trTR: {
        fill_in_at_least_one_query_condition: 'En azından bir soru durumunu doldur',
        query_time: 'Sorgulama zamanı',
        full_query: 'Tam sorgulama',
        organization_code: 'Organizasyon CODE',
        organization_name: 'Organizasyon adı',
        country: 'Ülke',
        number_of_cases: 'Toplam dosyalar',
        number_of_case_responses: '24H Vaka yanıtlarının sayısı',
        response_rate: '24H Yanıt oranı',
    },
    // 捷克语
    csCZ: {
        fill_in_at_least_one_query_condition: 'Vyplňte alespoň jednu podmínku dotazu',
        query_time: 'Čas dotazu',
        full_query: 'Úplný dotaz',
        organization_code: 'Kód společnosti',
        organization_name: 'Název společnosti',
        country: 'Země',
        number_of_cases: 'Počet případů',
        number_of_case_responses: 'Počet odpovědí případu za 24 hodin',
        response_rate: '24hodinová rychlost odezvy',
    },
    // 匈牙利语
    huHU: {
        fill_in_at_least_one_query_condition: 'Töltsön ki legalább egy lekérdezési feltételt',
        query_time: 'Lekérdezési idő',
        full_query: 'Teljes lekérdezés',
        organization_code: 'Szervezet kódja',
        organization_name: 'Szervezet neve',
        country: 'Ország',
        number_of_cases: 'Esetek száma',
        number_of_case_responses: '24 órán belüli esetreakciók száma',
        response_rate: '24 órás reagálási arány',
    },
    // 俄罗斯语
    ruRU: {
        fill_in_at_least_one_query_condition: 'Заполните хотя бы одно условие запроса',
        query_time: 'Время запроса',
        full_query: 'Полный запрос',
        organization_code: 'Код организации',
        organization_name: 'Название организации',
        country: 'Страна',
        number_of_cases: 'Общее количество случаев',
        number_of_case_responses: 'Количество ответов по случаям в течение 24 часов',
        response_rate: 'Коэффициент ответов в течение 24 часов',
    },
    // 沙特阿拉伯
    arSA: {
        fill_in_at_least_one_query_condition: 'يُرجى تعبئة شرط بحث واحد على الأقل',
        query_time: 'وقت الاستعلام',
        full_query: 'استعلام كامل',
        organization_code: 'رمز المنظمة',
        organization_name: 'اسم المنظمة',
        country: 'الدولة',
        number_of_cases: 'إجمالي عدد الحالات',
        number_of_case_responses: 'عدد الردود على الحالات خلال 24 ساعة',
        response_rate: 'نسبة الرد خلال 24 ساعة',
    },
    // 保加利亚
    bgBG: {
        fill_in_at_least_one_query_condition: 'Попълнете поне едно условие за търсене',
        query_time: 'Време на заявката',
        full_query: 'Пълно запитване',
        organization_code: 'Код на организацията',
        organization_name: 'Име на организацията',
        country: 'Държава',
        number_of_cases: 'Общ брой случаи',
        number_of_case_responses: 'Брой отговорени случая в рамките на 24 часа',
        response_rate: 'Процент отговори в рамките на 24 часа',
    },
    // 丹麦语
    daDK: {
        fill_in_at_least_one_query_condition: 'Udfyld mindst ét søgekriterie',
        query_time: 'Forespørgselstidspunkt',
        full_query: 'Fuld forespørgsel',
        organization_code: 'Organisationskode',
        organization_name: 'Organisationsnavn',
        country: 'Land',
        number_of_cases: 'Samlet antal sager',
        number_of_case_responses: 'Antal svar på sager inden for 24 timer',
        response_rate: 'Svarprocent inden for 24 timer',
    },
    // 芬兰语
    fiFI: {
        fill_in_at_least_one_query_condition: 'Täytä vähintään yksi hakuehto',
        query_time: 'Kyselyn aika',
        full_query: 'Täydellinen kysely',
        organization_code: 'Organisaatiokoodi',
        organization_name: 'Organisaation nimi',
        country: 'Maa',
        number_of_cases: 'Tapauksien kokonaismäärä',
        number_of_case_responses: '24 tunnin sisällä vastattujen tapausten määrä',
        response_rate: '24 tunnin vastausprosentti',
    },
    // 繁体中文台湾
    zhTW: {
        fill_in_at_least_one_query_condition: '至少填寫一個查詢條件',
        query_time: '查詢時間',
        full_query: '全量查詢',
        organization_code: '組織CODE',
        organization_name: '組織名稱',
        country: '國家',
        number_of_cases: '案例總數',
        number_of_case_responses: '24小時案件答覆數量',
        response_rate: '24小時答覆比率',
    },
    // 克罗地亚
    hrHR: {
        fill_in_at_least_one_query_condition: 'Unesite barem jedan uvjet pretraživanja',
        query_time: 'Vrijeme upita',
        full_query: 'Potpuno pretraživanje',
        organization_code: 'Kôd organizacije',
        organization_name: 'Naziv organizacije',
        country: 'Država',
        number_of_cases: 'Ukupan broj slučajeva',
        number_of_case_responses: 'Broj odgovora na slučajeve unutar 24 sata',
        response_rate: 'Postotak odgovora unutar 24 sata',
    },
    // 拉脱维亚
    lvLV: {
        fill_in_at_least_one_query_condition: 'Aizpildiet vismaz vienu meklēšanas nosacījumu',
        query_time: 'Vaicājuma laiks',
        full_query: 'Pilns vaicājums',
        organization_code: 'Organizācijas kods',
        organization_name: 'Organizācijas nosaukums',
        country: 'Valsts',
        number_of_cases: 'Gadījumu kopējais skaits',
        number_of_case_responses: '24 stundu laikā atbildēto gadījumu skaits',
        response_rate: '24 stundu atbildes līmenis',
    },
    // 立陶宛
    ltLT: {
        fill_in_at_least_one_query_condition: 'Užpildykite bent vieną užklausos sąlygą',
        query_time: 'Užklausos laikas',
        full_query: 'Visapusiška užklausa',
        organization_code: 'Organizacijos kodas',
        organization_name: 'Organizacijos pavadinimas',
        country: 'Šalis',
        number_of_cases: 'Bylų bendras skaičius',
        number_of_case_responses: 'Per 24 valandas atsakytų bylų skaičius',
        response_rate: '24 valandų atsakymo santykis',
    },
    // 罗马尼亚
    roRO: {
        fill_in_at_least_one_query_condition: 'Completați cel puțin o condiție de căutare',
        query_time: 'Timpul interogării',
        full_query: 'Interogare completă',
        organization_code: 'Cod organizație',
        organization_name: 'Numele organizației',
        country: 'Țară',
        number_of_cases: 'Numărul total de cazuri',
        number_of_case_responses: 'Numărul de răspunsuri la cazuri în 24 de ore',
        response_rate: 'Rata de răspuns în 24 de ore',
    },
    // 挪威博克马尔
    nbNO: {
        fill_in_at_least_one_query_condition: 'Fyll ut minst ett søkekriterium',
        query_time: 'Spørringstidspunkt',
        full_query: 'Full spørring',
        organization_code: 'Organisasjonskode',
        organization_name: 'Organisasjonsnavn',
        country: 'Land',
        number_of_cases: 'Totalt antall saker',
        number_of_case_responses: 'Antall svar på saker innen 24 timer',
        response_rate: 'Svarprosent innen 24 timer',
    },
    // 葡萄牙语巴西
    ptBX: {
        fill_in_at_least_one_query_condition: 'Preencha pelo menos uma condição de consulta',
        query_time: 'Tempo de consulta',
        full_query: 'Consulta completa',
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        country: 'País',
        number_of_cases: 'Número total de casos',
        number_of_case_responses: 'Número de respostas a casos em 24 horas',
        response_rate: 'Taxa de resposta em 24 horas',
    },
    // 瑞典语
    svSE: {
        fill_in_at_least_one_query_condition: 'Fyll i minst ett sökvillkor',
        query_time: 'Frågetid',
        full_query: 'Fullständig fråga',
        organization_code: 'Organisationskod',
        organization_name: 'Organisationsnamn',
        country: 'Land',
        number_of_cases: 'Totalt antal ärenden',
        number_of_case_responses: 'Antal ärendesvar inom 24 timmar',
        response_rate: 'Svarsfrekvens inom 24 timmar',
    },
    // 斯洛伐克
    skSK: {
        fill_in_at_least_one_query_condition: 'Vyplňte aspoň jednu podmienku vyhľadávania',
        query_time: 'Čas dopytu',
        full_query: 'Úplný dopyt',
        organization_code: 'Kód organizácie',
        organization_name: 'Názov organizácie',
        country: 'Krajina',
        number_of_cases: 'Celkový počet prípadov',
        number_of_case_responses: 'Počet odpovedí na prípady do 24 hodín',
        response_rate: 'Miera odpovedí do 24 hodín',
    },
    // 斯洛文尼亚
    slSI: {
        fill_in_at_least_one_query_condition: 'Izpolnite vsaj en pogoj za poizvedbo',
        query_time: 'Čas poizvedbe',
        full_query: 'Polna poizvedba',
        organization_code: 'Koda organizacije',
        organization_name: 'Ime organizacije',
        country: 'Država',
        number_of_cases: 'Skupno število primerov',
        number_of_case_responses: 'Število odgovorov na primere v 24 urah',
        response_rate: 'Odstotek odgovorov v 24 urah',
    },
    // 泰语
    thTH: {
        fill_in_at_least_one_query_condition: 'กรุณากรอกเงื่อนไขการค้นหาอย่างน้อยหนึ่งรายการ',
        query_time: 'เวลาค้นหา',
        full_query: 'ค้นหาทั้งหมด',
        organization_code: 'รหัสองค์กร',
        organization_name: 'ชื่อองค์กร',
        country: 'ประเทศ',
        number_of_cases: 'จำนวนเคสทั้งหมด',
        number_of_case_responses: 'จำนวนการตอบกลับเคสภายใน 24 ชั่วโมง',
        response_rate: 'อัตราการตอบกลับภายใน 24 ชั่วโมง',
    },
    // 乌克兰语
    ukUA: {
        fill_in_at_least_one_query_condition: 'Заповніть принаймні одну умову запиту',
        query_time: 'Час запиту',
        full_query: 'Повний запит',
        organization_code: 'Код організації',
        organization_name: 'Назва організації',
        country: 'Країна',
        number_of_cases: 'Загальна кількість випадків',
        number_of_case_responses: 'Кількість відповідей на випадки протягом 24 годин',
        response_rate: 'Відсоток відповідей протягом 24 годин',
    },
    // 希腊语
    elGR: {
        fill_in_at_least_one_query_condition: 'Συμπληρώστε τουλάχιστον μία συνθήκη αναζήτησης',
        query_time: 'Χρόνος ερωτήματος',
        full_query: 'Πλήρης αναζήτηση',
        organization_code: 'Κωδικός οργανισμού',
        organization_name: 'Όνομα οργανισμού',
        country: 'Χώρα',
        number_of_cases: 'Συνολικός αριθμός περιστατικών',
        number_of_case_responses: 'Αριθμός απαντήσεων σε περιστατικά εντός 24 ωρών',
        response_rate: 'Ποσοστό απάντησης εντός 24 ωρών',
    },
    // 爱沙尼亚
    etEE: {
        fill_in_at_least_one_query_condition: 'Sisestage vähemalt üks päringutingimus',
        query_time: 'Päringu aeg',
        full_query: 'Täielik päring',
        organization_code: 'Organisatsiooni kood',
        organization_name: 'Organisatsiooni nimi',
        country: 'Riik',
        number_of_cases: 'Juhtumite koguarv',
        number_of_case_responses: '24 tunni jooksul vastatud juhtumite arv',
        response_rate: '24-tunnise vastuse määr',
    },
    // 哈萨克
    kkKZ: {
        fill_in_at_least_one_query_condition: 'Кем дегенде бір сұрау шартын толтырыңыз',
        query_time: 'Сұрау уақыты',
        full_query: 'Толық сұрау',
        organization_code: 'Ұйым коды',
        organization_name: 'Ұйым атауы',
        country: 'Ел',
        number_of_cases: 'Жағдайлардың жалпы саны',
        number_of_case_responses: '24 сағат ішіндегі жауап берілген жағдайлар саны',
        response_rate: '24 сағат ішіндегі жауап беру пайызы',
    },
    // 希伯来语
    heIL: {
        fill_in_at_least_one_query_condition: 'יש למלא לפחות תנאי שאילתה אחד',
        query_time: 'זמן השאילתה',
        full_query: 'שאילתה מלאה',
        organization_code: 'קוד ארגון',
        organization_name: 'שם הארגון',
        country: 'מדינה',
        number_of_cases: 'סך כל המקרים',
        number_of_case_responses: 'מספר תשובות למקרים בתוך 24 שעות',
        response_rate: 'אחוז תגובות בתוך 24 שעות',
    },
};
